import { post, postAPI, postFormData, postWithFormdata } from "./ApiHelpers.ts";
import {
  trackOTPSent,
  trackOTPVerified,
  trackLogin,
  trackSignup,
} from "../lib/analytics/eventTracking.ts";
import { logger } from "../utils/consoleLogger.ts";

export const googleAuth = async (payload) =>
  postAPI("validate_google_auth", payload);

export const sendOtp = async (email: string) => {
  const result = await postAPI(`send_otp`, { email, phone: "" });
  if (result.status) {
    trackOTPSent(email);
  }
  return result;
};

export const validateOtp = async (email: string, otp: string, slug) => {
  const result = await postAPI(
    `validate_otp_for_company_user`,
    {
      email: email,
      otp: otp,
    },
    false,
    { slug: slug }
  );
  if (result.status) {
    trackOTPVerified(email);
    trackLogin(email, "otp");
  }
  return result;
};

export const onboardCompany = async (data) => {
  const result = await postAPI(`company/onboard/`, data);
  if (result.status) {
    const email = data.email;
    const companyName = data.company_name;
    if (email) {
      trackSignup(email, companyName);
    }
  }
  return result;
};

// Multipart variant so the company logo file rides along with the
// onboarding payload (same approach as the Company Details page upload).
export const onboardCompanyMultipart = async (formData: FormData) => {
  try {
    const data = await postFormData(`/company/onboard/`, formData);
    const email = formData.get("email") as string;
    const companyName = formData.get("company_name") as string;
    if (email) {
      trackSignup(email, companyName);
    }
    return { status: true, data };
  } catch (e: any) {
    let error: any = {};
    try {
      error = JSON.parse(e?.target?.responseText || "{}");
    } catch {
      /* non-JSON error body */
    }
    logger.error("Onboarding multipart submit failed", error);
    return { status: false, error };
  }
};

export const joinCompany = async (data) =>
  postWithFormdata(`company/join_company`, data);

export function getCurrentUserDetailsFromLocalStorage() {
  try {
    const authData = localStorage.getItem("babblebots_auth_data");
    return authData ? JSON.parse(authData) : null;
  } catch (e) {
    logger.warn("Stored auth data is not valid JSON", e);
    return null;
  }
}
export const isTokenValid = (currentUser) => {
  return (
    currentUser?.token &&
    new Date(currentUser.expiry).getTime() >
      new Date(new Date().toUTCString()).getTime()
  );
};

export function getAuthToken() {
  let currentUser = getCurrentUserDetailsFromLocalStorage();
  return isTokenValid(currentUser) ? currentUser?.token : null;
}
